<template>
    <div>
        <p class="card-text"><span>{{ this.item }}</span></p>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    props:['item']
}
</script>
<style scoped>
.card-text span {
    color: #2C3F5E;
    font-size: 12px;
    line-height: 19px;
    letter-spacing: 0%;
    font-weight: 600;
    background-color: #EEF2F9;
    padding-top:2px;
    padding-bottom:4px;
    padding-left:10px;
    padding-right:10px;
    border-radius: 8px;
}

</style>